<span class="ltms-description">{{ mainDiscription }}</span>
<div [ngClass]="{'hidden': !((isDataLoaded == true && isDataAvailable == true) || engagementService.getFullScreen('bar-view'))}">
  <ng-container *ngIf="!restrictToday; else blankMessage">
    <app-engagement-lite (onCheckBoxChange)="onCheckboxClick($event)" (onOptionChangeEvent)="onOptionChange($event)" [isEngagementPro]="true" [isDeviationEnabled]="isDeviationEnabled"></app-engagement-lite>
    <div class="response-rate-trend" *ngIf="showRecordsJourney && isRecordsJourneyLoaded == true">
      <app-engagement-stackbar [values]="recordsJourneyData" [displayName]="displayName" [isDataLoaded]="isChartDataLoaded" [isDeviationEnabled]="isDeviationEnabled"></app-engagement-stackbar>
    </div>
    <div class="response-distribution" *ngIf="showResponseDistribution">
      <app-engagement-doughnut-chart [values]="responseDistribution" [displayName]="displayName" [isDataLoaded]="isChartDataLoaded"></app-engagement-doughnut-chart>
    </div>
    <div class="channel-performance" *ngIf="showChannelPerformance && isRecordsJourneyLoaded == true">
      <app-engagement-channel-performance [data]="recordsJourneyData" [displayName]="displayName" [isDataLoaded]="isChartDataLoaded"></app-engagement-channel-performance>
    </div>
  </ng-container>
  <ng-template #blankMessage>
    <div class="no-data-message error-text">No data available for the current date range. Try changing the date range.</div>
  </ng-template>
</div>
<div class="data-details-loader" *ngIf="isDataLoaded == false && !engagementService.getFullScreen('bar-view')" style="height: 30vh;">
  <app-ltms-loader></app-ltms-loader>
</div>
<div *ngIf="isDataLoaded == true && isDataAvailable == false">
  <app-ltms-error [code]="errorCode"></app-ltms-error>
</div>